(function () {
  'use strict';
  var config = window.PFMUKOffersConfig || window.PFMAUOffersConfig;
  if (!config) return;
  var isUK = config === window.PFMUKOffersConfig && Number(config.marketId) === 15894052973;
  var isAU = config === window.PFMAUOffersConfig && Number(config.marketId) === 15895855213;
  if (!isUK && !isAU) return;
  var offerNamespace = isUK ? 'PFMUKOffers' : 'PFMAUOffers';
  if (window[offerNamespace]) return;
  var noticeAttribute = isUK ? 'data-uk-promo-notice' : 'data-au-promo-notice';

  var running = null;
  var attemptedCart = '';
  var entryIntent = new URLSearchParams(location.search).get('pfm_purchase');
  var intentApplied = false;
  var promoCode = String(config.promoCode || 'PH25').toUpperCase();

  function requestCart(url, body) {
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 5000);
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body ? JSON.stringify(body) : undefined,
      signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Regional cart update unavailable');
      return response.json();
    }).finally(function () { clearTimeout(timeout); });
  }

  function hasTargetOneTime(cart) {
    return (cart.items || []).some(function (item) {
      return Number(item.product_id) === Number(config.autoApplyProductId) &&
        Number(item.quantity) > 0 && !item.selling_plan_allocation;
    });
  }

  function hasOtherDiscount(cart) {
    var codes = cart.discount_codes || [];
    var applications = (cart.cart_level_discount_applications || []).concat(
      (cart.items || []).flatMap(function (item) {
        return (item.line_level_discount_allocations || []).map(function (allocation) {
          return allocation.discount_application || {};
        });
      })
    );
    return codes.some(function (entry) {
      return String(entry.code || '').toUpperCase() !== promoCode;
    }) || applications.some(function (entry) {
      return String(entry.title || '').toUpperCase() !== promoCode;
    });
  }

  function applied(cart) {
    return (cart.discount_codes || []).some(function (entry) {
      return String(entry.code || '').toUpperCase() === promoCode && entry.applicable;
    }) || (cart.items || []).some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (entry) {
        return String(entry.discount_application && entry.discount_application.title || '').toUpperCase() === promoCode;
      });
    });
  }

  function fingerprint(cart) {
    return String(cart.token || '') + '|' + (cart.items || []).filter(function (item) {
      return Number(item.product_id) === Number(config.autoApplyProductId) && !item.selling_plan_allocation;
    }).map(function (item) { return String(item.variant_id); }).sort().join(',');
  }

  function showFailure() {
    var form = document.querySelector('.product-single__form[data-productid="' + config.autoApplyProductId + '"]');
    if (!form || form.querySelector('[' + noticeAttribute + ']')) return;
    var notice = document.createElement('p');
    notice.setAttribute(noticeAttribute, '');
    notice.setAttribute('role', 'status');
    notice.className = 'product__policies';
    notice.textContent = 'PH25 could not be applied automatically. You can enter it at checkout for eligible one-time purchases.';
    form.appendChild(notice);
  }

  function ensurePromo(knownEligible) {
    // Australia is being prepared in QA before PH25 is enabled for its market.
    // Never simulate a discount or alter a cart while the backend is pending.
    // Undefined preserves the already-live UK configuration and behavior.
    if (config.promotionEnabled === false || (isAU && config.promotionEnabled !== true)) return Promise.resolve(null);
    if (running) return running;
    var promoRelevant = knownEligible === true;
    running = requestCart(config.cartUrl).then(function (cart) {
      promoRelevant = hasTargetOneTime(cart);
      if (!promoRelevant || hasOtherDiscount(cart) || applied(cart)) {
        document.querySelectorAll('[' + noticeAttribute + ']').forEach(function (el) { el.remove(); });
        return cart;
      }
      var cartFingerprint = fingerprint(cart);
      // Respect a removal made after our successful attempt; do not fight the
      // shopper or repeatedly retry an expired/ineligible promotion on events.
      if (attemptedCart === cartFingerprint) return cart;
      attemptedCart = cartFingerprint;
      return requestCart(config.cartUpdateUrl, { discount: promoCode }).then(function (updated) {
        if (!applied(updated)) showFailure();
        else document.querySelectorAll('[' + noticeAttribute + ']').forEach(function (el) { el.remove(); });
        document.dispatchEvent(new CustomEvent(isUK ? 'pfm:uk-offer-updated' : 'pfm:au-offer-updated', { detail: { applied: applied(updated) } }));
        // The full cart is server-rendered. Refresh its native line prices and
        // subtotal after changing a discount on an already populated cart.
        if (/\/cart\/?$/.test(location.pathname)) {
          document.dispatchEvent(new CustomEvent('cart:build'));
        }
        return updated;
      });
    }).catch(function () {
      attemptedCart = '';
      if (promoRelevant) showFailure();
      // The item was already added successfully. A promo network failure must
      // never convert it, repeat the add, or strand the add-to-cart button.
      return null;
    }).finally(function () { running = null; });
    return running;
  }

  function applyLandingIntent() {
    if (intentApplied || !['one_time', 'subscription'].includes(entryIntent)) return;
    var form = document.querySelector('.product-single__form[data-productid="' + config.autoApplyProductId + '"]');
    var context = form && (form.closest('.product-section') || form.closest('.shopify-section'));
    if (!context || !context.querySelector('[name="stayai_selling_plan"]')) return;
    var radio = context.querySelector(entryIntent === 'one_time' ? '#purchaseTypeOneTime' : '#purchaseTypeSubscription');
    var label = radio && context.querySelector('label[for="' + radio.id + '"]');
    if (!radio || !label) return;
    if (!radio.checked) radio.click();
    // Stay AI inserts its controls before its change handler is always ready.
    // A native click can set the radio without updating the app's selected
    // label/frequency state. Notify the app again until both states agree.
    if (!label.classList.contains('is-selected')) {
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    intentApplied = radio.checked && label.classList.contains('is-selected');
  }

  window[offerNamespace] = {
    afterAdd: function (product) {
      var items = product && product.items || [product || {}];
      if (!items.some(function (item) { return Number(item.product_id) === Number(config.autoApplyProductId); })) {
        return Promise.resolve(null);
      }
      return ensurePromo(items.some(function (item) {
        return Number(item.product_id) === Number(config.autoApplyProductId) && !item.selling_plan_allocation;
      }));
    },
    ensurePromo: ensurePromo
  };

  function boot() {
    if (['one_time', 'subscription'].includes(entryIntent)) {
      var intentInterval;
      var intentDeadline;
      function stopIntent() {
        intentApplied = true;
        clearInterval(intentInterval);
        clearTimeout(intentDeadline);
        document.removeEventListener('pointerdown', respectShopper, true);
        document.removeEventListener('keydown', respectShopper, true);
      }
      function respectShopper(event) {
        if (event.isTrusted && event.target.closest &&
            event.target.closest('.stayai-purchase-label, [name="stayai_selling_plan"], input[name="purchaseType"]')) {
          // A deliberate shopper selection always wins over the entry link.
          stopIntent();
        }
      }
      function tryIntent() {
        applyLandingIntent();
        if (intentApplied) stopIntent();
      }
      document.addEventListener('pointerdown', respectShopper, true);
      document.addEventListener('keydown', respectShopper, true);
      intentInterval = setInterval(tryIntent, 250);
      intentDeadline = setTimeout(stopIntent, 15000);
      tryIntent();
    }
    // Returning to an existing eligible cart should not require the landing
    // page or a discount redirect to have been visited earlier in the session.
    if (/\/cart\/?$/.test(location.pathname)) ensurePromo();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
